import './TurboTaxTable.scss';

import React, { Fragment } from 'react';

import Content, { contentConverter } from 'services/Content';

const PSTurboTaxTable = () => {
  return (
    <Fragment>
      <p>
        Get your taxes done right and save. As a T. Rowe Price Personal Services
        Client, choose among a suite of Free and Discounted TurboTax products
        (see offer details below). TurboTax will help you choose the product
        that best meets your needs.
      </p>
      <table className="table">
        <tbody>
          <tr>
            <td>Free Products</td>
            <td>Discounted Products</td>
          </tr>
          <tr className="table-content">
            <td>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(Content.psTurboTaxDeluxe)
                  }}
                />
              </ul>
            </td>
            <td>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.upgradedTurboTaxPremire
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxDeluxeDesktop
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.psTurboTaxPremierDesktop
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxSelfEmployed
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxBusiness
                    )
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: contentConverter.makeHtml(
                      Content.discountedTurboTaxProducts
                    )
                  }}
                />
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Users of TurboTax may receive offers for additional products or services
        provided by Intuit. These offers are not supplied or endorsed by T. Rowe
        Price.
      </p>
    </Fragment>
  );
};

export default PSTurboTaxTable;
